import { AttachmentList } from "@/modules/patients/components/attachments/attachment-list"
import { useAppointmentAttachments } from "@/modules/patients/detail/progress-note/hooks/useAppointmentAttachments"
import { AppointmentAttachmentFragment$key } from "@/modules/waiting-room/services/__generated__/AppointmentAttachmentFragment.graphql"

interface Doc2UAttachmentsProps {
  appointmentAttachments: AppointmentAttachmentFragment$key
}

const Doc2UAttachments = ({ appointmentAttachments }: Doc2UAttachmentsProps) => {
  const attachments = useAppointmentAttachments({ uploadSources: ["DOC2_U"], appointmentAttachments })

  if (!attachments || attachments.length === 0) return null

  return <AttachmentList mediaFiles={attachments} />
}

export { Doc2UAttachments }
